import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ValidationService } from '../../../../../../shared/_services/validation.service';
import { ActivatedRoute, Router } from '@angular/router';

import { HcaUserManagementService } from '../../../../../../shared/_services/hca-user-management.service';

@Component({
  selector: 'app-hca-user-management-details',
  templateUrl: './hca-user-management-details.component.html',
  styleUrls: ['./hca-user-management-details.component.scss']
})
export class HcaUserManagementDetailsComponent implements OnInit {
  hcaStatus: any;
  errorDetails: any;
  AdminList: any[];
  hcaRoles: any[];
  hotelBrands: any[];
  hotels: any[];
  hcaId: number;
  user: FormGroup;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private validationService: ValidationService,
    private hcaUserManagementService: HcaUserManagementService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.hcaId = +params['id']; // (+) converts string 'id' to a number
    });
    this.getHcaInfo(this.hcaId);
    this.getRolesForHCA();

    this.user = this.fb.group({
      roleId: ['', Validators.required],
      brandId: ['', Validators.required],
      hotelId: ['', Validators.required],
      isAllBrandsSelected: [false],
      isAllHotelsSelected: [false],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      // email: ['', Validators.compose([Validators.required, Validators.pattern(this.validationService.email_regexPattern)])],
      email: ['', Validators.compose([Validators.required])],
      // mobileNumber: ['', Validators.compose([Validators.minLength(10), Validators.maxLength(12), Validators.pattern(this.validationService.phoneNumber_regexPattern)])],
      mobileNumber: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(15)])],
      skypeId: ['']
    });
    this.user.get('roleId').valueChanges
      .subscribe(value => {
        console.log("Admin Role : " + value);
        const brand = this.user.get('brandId');
        const hotel = this.user.get('hotelId');
        brand.enable();
        hotel.enable();
        if(!brand.value && !hotel.value) {
          this.hotelBrands=[];
          this.hotels=[];
          this.user.get('hotelId').setValue("", { emitEvent: false });
          this.user.get('brandId').setValue("", { emitEvent: false });
        }
        if(value == '' || value == null) {
          brand.disable();
          hotel.disable();
          this.hotelBrands=[];
          this.hotels=[];
          this.user.get('hotelId').setValue("", { emitEvent: false });
          this.user.get('brandId').setValue("", { emitEvent: false });
        }
        if (value != 12) {
          this.getHotelBrandsByHotelChain();
          
          if(value == 14 && brand.value) {
            hotel.enable();
          } else {
            hotel.disable();
            this.hotels=[];
            this.user.get('hotelId').setValue("", { emitEvent: false });
          }
        }
        else{
          brand.disable();
          hotel.disable();
          this.hotelBrands=[];
          this.hotels=[];
          this.user.get('hotelId').setValue("", { emitEvent: false });
          this.user.get('brandId').setValue("", { emitEvent: false });
        }
      });
    this.user.get('brandId').valueChanges
      .subscribe(value => {
        console.log("Brand Id : " + value);
        const hotel = this.user.get('hotelId');
        if (value && this.user.get('roleId').value == 14) {
          hotel.enable();
          this.user.get('hotelId').setValue("", { emitEvent: false });
          this.getHotelsByBrand(value);
        }
        else{
          hotel.disable();
          this.hotels=[];
          this.user.get('hotelId').setValue("", { emitEvent: false });
        }
      });
  }
  updateUserStatue(status) {
    this.hcaUserManagementService.changeHcaUserStatus(this.hcaId, status).subscribe(
      data => {
        document.getElementById('deleteModal').click();
        document.getElementById('activateModal').click();
        this.router.navigate(['/settings/hca-user-management']);
      }, error => {
      });
  }

  getHcaInfo(id) {
    this.hcaUserManagementService.getHcaInfo(id).subscribe(
      res => {
        if (res.error == 0) {
          console.log('=====res======',res);
          this.user.patchValue(res.responseObj);
          this.hcaStatus = res.responseObj.status;

          // console.log("Admin Role : " + this.user.get('roleId').value);
          // const brand = this.user.get('brandId');
          // const hotel = this.user.get('hotelId');
          // if((this.user.get('roleId').value == '' || this.user.get('roleId').value == null) && (!brand.value || !hotel.value)) {
          //   brand.disable();
          //   hotel.disable();
          //   this.hotelBrands=[];
          //   this.hotels=[];
          //   this.user.get('hotelId').setValue("", { emitEvent: false });
          //   this.user.get('brandId').setValue("", { emitEvent: false });
          // }
        } else {
          console.error("Get Hotel Chain Admin Details : " + res.message);
        }
      }, error => {
        console.error(error);
      });
  }
  getRolesForHCA() {
    this.hcaUserManagementService.getRolesForHCA().subscribe(
      res => {
        if (res.error == 0) {
          this.hcaRoles = res.responseObj;
        }
        else {
          console.error("Get Admin Roles : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }
  getHotelBrandsByHotelChain() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
      res => {
        if (res.error == 0) {
          this.hotelBrands = res.responseObj;
        }
        else {
          console.error("Get Hotel Brands : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }
  getHotelsByBrand(brandId) {
    this.hotels=[];
    this.hcaUserManagementService.getHotelsByBrand([brandId]).subscribe(
      res => {
        if (res.error == 0) {
          this.hotels = res.responseObj;
        }
        else {
          this.user.get('hotelId').setValue("", { emitEvent: false });
          console.error("Get Hotels : " + res.message);
        }
      }, err => {
        console.error(err);
      });
  }
  saveUser(user) {
    if (this.user.get('roleId').value == 12) {//HCA
      this.user.get('brandId').setValue(null, { emitEvent: false });
      this.user.get('hotelId').setValue(null, { emitEvent: false });

      this.user.get('isAllBrandsSelected').setValue(true);
      this.user.get('isAllHotelsSelected').setValue(true);
    }
    else if (this.user.get('roleId').value == 13) {//BA
      this.user.get('hotelId').setValue(null, { emitEvent: false });

      this.user.get('isAllBrandsSelected').setValue(false);
      this.user.get('isAllHotelsSelected').setValue(true);
    }
    else if (this.user.get('roleId').value == 14) {//HA
      this.user.get('isAllBrandsSelected').setValue(false);
      this.user.get('isAllHotelsSelected').setValue(false);
    }
    console.log(user.value);
    user.value.userId = this.hcaId;
    this.hcaUserManagementService.updateHcaAdmin(user.value).subscribe(
      res => {
        if (res.error == 0) {
          this.router.navigate(['/settings/hca-user-management']);
        }
        else {
          this.errorDetails = res.message;
        }
      }, err => {
        console.error(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-user-management/hca-user-management-details/hca-user-management-details.component.ts